import { SoundManagementRepository } from '../data/sound-management-repository';
import { MediaListParams, MediaListResponse } from '../types/sound-management-types';

/**
 * Get Sounds Use Case
 * Retrieves sounds list with filtering and pagination
 */
export class GetSoundsUseCase {
  constructor(private readonly repository: SoundManagementRepository) {}

  async execute(params: MediaListParams): Promise<MediaListResponse> {
    return this.repository.getSounds(params);
  }
}
